module.exports = __webpack_public_path__ + "static/media/phone.4289d2d8.svg";